import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './LoginForm.scss';

import validateLogin from './validateLogin';
import {
    Form,
    Button,
    FormTextField,
    ErrorMessage,
    ButtonLink
} from 'components/controls';
import {isForbiddenError, isUnauthorizeError} from '../../../sources/ApiError';


export default class LoginForm extends Component {
    static propTypes = {
        login: PropTypes.object,
        loginProcessing: PropTypes.bool,
        loginError: PropTypes.object,
        onLogin: PropTypes.func.isRequired,
        onHideLogin: PropTypes.func.isRequired,
        onSignUpLinkClick: PropTypes.func.isRequired,
        onForgotPasswordClick: PropTypes.func.isRequired
    };


    state = {
        email: '',
        password: ''
    };

    componentWillUnmount() {
        if (this.props.loginError)
            this.props.onHideLogin();
    }

    render() {
        const {loginProcessing, loginError, onSignUpLinkClick, onForgotPasswordClick} = this.props;
        const authError = loginError && isUnauthorizeError(loginError);
        const errorMessage = authError && loginError.details ? loc(loginError.details) : loc('credentials-mismatch');
        const bannedError = loginError && isForbiddenError(loginError);
        return (
            <Form className={styles.form}
                  fieldValues={this.state}
                  clientValidate={validateLogin}
                  processing={loginProcessing}
                  onFieldChange={::this.handleFieldChanged}
                  onSubmit={::this.handleLogin}
                  ref='form'>

                <FormTextField fieldKey='email'
                               type='text'
                               label={loc('email-label')}
                               placeholder={loc('email-placeholder')}/>

                <FormTextField fieldKey='password'
                               type='password'
                               label={loc('password-label')}
                               placeholder={loc('password-login-placeholder')}/>
                <ButtonLink label={loc('forgot-password-label')}
                            className={styles.greyLink}
                            onClick={onForgotPasswordClick}
                />

                <ErrorMessage type='commonErrors'>
                    {authError && errorMessage}
                    {bannedError && loc('account-banned')}
                </ErrorMessage>

                <Button type='submit'
                        label={loc('login-label')}
                        className={styles.submitButton}/>

                <div className={styles.formNote}>{loc('not-account')}
                    <ButtonLink label={loc('sign-up-label')}
                                onClick={onSignUpLinkClick}
                                className={styles.link}/>
                </div>

            </Form>
        );
    }

    handleLogin() {
        const {onLogin} = this.props;
        const {
            password, email
        } = this.state;


        onLogin({
            password, email
        });
    }

    handleFieldChanged(fieldKey, {target: {value}}) {
        this.setState({
            [fieldKey]: value
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/Auth/Login/LoginForm.js